export const MsTeamsMeetingProvidersEnum = {
    microsoftTeams: {
        key: "microsoft_teams",
        value: 'microsoft-teams',
    },
    skypeForBusiness: {
        key: 'skypeForBusiness',
        value: 'skype-for-business',
    },
    skypeForConsumer: {
        key: 'skypeForConsumer',
        value: 'skype-for-consumer',
    },
    teamsForBusiness: {
        key: 'teamsForBusiness',
        value: 'teams-for-business',
    },
    unknown: {
        key: 'unknown',
        value: 'teams-for-live',
  },
};